'use es6';

import { ACTIVE_HUB_UPDATED } from 'pricing-pages-unified-ui/constants/ActionTypes';

const ActiveHub = (state = null, {
  type,
  payload
}) => {
  switch (type) {
    case ACTIVE_HUB_UPDATED:
      return payload.hub;

    default:
      return state;
  }
};

export default ActiveHub;